var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import qs from "qs";
import { Redirect } from "react-router";
import { injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import History from "@irati/utils/history";
import tracking from "@irati-tracking/wallet/tenantWallet";
import PaymentForm from "@irati-web/payments/src/components/PaymentForm";
import { getDomain } from "@irati/utils/links";
import endpoints from "@irati/payments/endpoints";
import topupService from "@irati/wallet/services/TopUp";
import CardConfirmationPopUp from "./CardConfirmationPopUp";
import ErrorCard from "./ErrorCard";
var CardPaymentFormV2 = /** @class */ (function (_super) {
    __extends(CardPaymentFormV2, _super);
    function CardPaymentFormV2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showCompletionModal: false,
            isError: false
        };
        _this.handleCardError = function () {
            _this.setState({ isError: true });
        };
        _this.goBackToTransactions = function () {
            History.push({
                pathname: "/wallet/tenant"
            });
        };
        _this.handleTryAgain = function () {
            var tenantWalletTopup = _this.props.tenantWalletTopup;
            History.push({
                pathname: "/wallet/tenant/top-up",
                tenantWalletTopup: tenantWalletTopup
            });
        };
        _this.getPaymentRedirectUrl = function () {
            var tenantWalletTopup = _this.props.tenantWalletTopup;
            var domain = getDomain(authentication.userTenant().subdomain);
            var query = qs.stringify({
                redirectTo: domain + "/wallet/tenant/top-up/confirm/" + tenantWalletTopup.uuid
            });
            return endpoints.adyenRedirectCallbackUrl() + "?" + query;
        };
        _this.getTopupStatus = function () {
            var _a, _b;
            return topupService.complete((_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.tenantWalletTopup) === null || _b === void 0 ? void 0 : _b.uuid).then(function () {
                tracking.completeTenantWalletTopUp();
                _this.setState({ showCompletionModal: true });
            }).catch(_this.handleCardError);
        };
        return _this;
    }
    CardPaymentFormV2.prototype.render = function () {
        var _a = this.state, showCompletionModal = _a.showCompletionModal, isError = _a.isError;
        var tenantWalletTopup = this.props.tenantWalletTopup;
        if (!tenantWalletTopup) {
            return React.createElement(Redirect, { to: "wallet/tenant/top-up" });
        }
        if (isError) {
            return React.createElement(ErrorCard, { goBackToTransactions: this.goBackToTransactions, handleTryAgain: this.handleTryAgain });
        }
        if (showCompletionModal) {
            return (React.createElement(CardConfirmationPopUp, { tenantWalletTopup: tenantWalletTopup, goBackToTransactions: this.goBackToTransactions, showCompletionModal: showCompletionModal }));
        }
        return (React.createElement(PaymentForm, { paymentOrder: tenantWalletTopup.paymentOrder, amount: tenantWalletTopup.amount, onComplete: this.getTopupStatus, redirectReturnUrl: this.getPaymentRedirectUrl() }));
    };
    return CardPaymentFormV2;
}(PureComponent));
export default injectIntl(CardPaymentFormV2);
